<template>
	<div class="avatar-selector">
		<div class="avatars">
			<div class="avatarwrap">
				<img :src="getAvatarById(selectedAvatar)?.image || getAvatarById('1')?.image" :alt="getAvatarById(selectedAvatar)?.name  || getAvatarById('1')?.name" class="currentAvatar" />
				<span class="openselector" @click="toggleActive" :class="{ active: isActive }"></span>
			</div>
			<div class="selector" :class="{ 'visible': isActive }">
				<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" class="logo"/>
				<h2>{{ t('txt_change')}}</h2>
				<h1>{{ t('txt_profile_image') }}</h1>
				<div class="list">
					<div v-for="avatar in avatars" :key="avatar.id" class="avatar"
						:class="{ selected: avatar.id === selectedAvatar }" @click="selectAvatar(avatar.id);">
						<img :src="avatar.image" :alt="avatar.name" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import apiClient from '../utils/axios';
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
export default {
	name: 'AvatarSelector',
	props: {
		avatars: {
			type: Array,
			required: true,
		},
		modelValue: {
			type: String,
			default: null,
		},
	},
	setup() {
		const { t } = useI18n();
		return {
			t
		};
	},
	data() {
		return {
			isActive: false,
			selectedAvatar: this.modelValue,
		};
	},
	methods: {
		selectAvatar(id) {
			this.selectedAvatar = id;
			this.$emit('update:modelValue', id);
			this.isActive = !this.isActive;
			const data = {'avatar': this.selectedAvatar, 'keycloak_id': keycloak.tokenParsed.sub }
			localStorage.setItem('avatar', this.selectedAvatar);
			this.updateUser(data);
		},
		getAvatarById(id) {
			return this.avatars.find(avatar => avatar.id === id);
		},
		toggleActive() {
			this.isActive = !this.isActive;
		},
		updateUser(data){
			apiClient.post('/'+localStorage.getItem('lang')+'/api/user/update', data)
						.then(response => {
							console.log(response);
						})
						.catch(apiError => {
							console.error('Failed to send user data:', apiError);
						});
		}
	},
	watch: {
		modelValue(newValue) { 
			this.selectedAvatar = newValue;
		},
	},
};
</script>

<style lang="sass" scoped>
.avatar-selector {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 50px;
	.avatars {
		display: flex;
		flex-wrap: wrap;
		.avatarwrap {
			position: relative;
			.openselector {
				position: absolute;
				right: -10px;
				bottom: -10px;
				width: 36px;
				height: 36px;
				background: #FFFFFF url('../assets/img/change.svg') center center no-repeat;
				border-radius: 50%;
			}
		}
		.selector {
			display: none;
			position: fixed;
			left: 0px;
			top: 0px;
			right: 0px;
			bottom: 0px;
			background: #2A2E43;
			padding: 30px;
			z-index: 1047;
			h2 {
				margin-top: 60px;
				margin-bottom: 0px;
			}
			h1 {
				margin-top: 0;
			}
			.list {
				display: flex;
				flex-wrap: wrap;
				gap: 30px;
				justify-content: space-evenly;
				.avatar {
					cursor: pointer;
					width: 25%;
					display: flex;
					align-items: flex-end;
					opacity: 1;
					img {
						max-width: 100%;
					}
					&.selected {
						position: relative;
						opacity: 0.4;
						/* &::after {
							content: "";
							position: absolute;
							right: -10px;
							bottom: -10px;
							width: 36px;
							height: 36px;
							background: #FFFFFF url('../assets/img/selected.svg') center center no-repeat;
							border-radius: 50%;
						} */
					}
				}
			}
			&.visible {
				display: block;
			}
		}
	}
}

</style>